const SvgConfigurationManagement = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_477_7992)">
        <path
          d="M21.3333 4H2.66665C2.31302 4 1.97389 4.14048 1.72384 4.39052C1.47379 4.64057 1.33331 4.97971 1.33331 5.33333V18.6667C1.33331 19.0203 1.47379 19.3594 1.72384 19.6095C1.97389 19.8595 2.31302 20 2.66665 20H21.3333C21.6869 20 22.0261 19.8595 22.2761 19.6095C22.5262 19.3594 22.6666 19.0203 22.6666 18.6667V5.33333C22.6666 4.97971 22.5262 4.64057 22.2761 4.39052C22.0261 4.14048 21.6869 4 21.3333 4ZM21.3333 18.6667H2.66665V5.33333H21.3333V18.6667Z"
          fill="#514B4D"
        />
        <path
          d="M5.99998 9.33333H18C18.1768 9.33333 18.3464 9.2631 18.4714 9.13807C18.5964 9.01305 18.6666 8.84348 18.6666 8.66667C18.6666 8.48986 18.5964 8.32029 18.4714 8.19526C18.3464 8.07024 18.1768 8 18 8H5.99998C5.82317 8 5.6536 8.07024 5.52858 8.19526C5.40355 8.32029 5.33331 8.48986 5.33331 8.66667C5.33331 8.84348 5.40355 9.01305 5.52858 9.13807C5.6536 9.2631 5.82317 9.33333 5.99998 9.33333Z"
          fill="#514B4D"
        />
        <path
          d="M5.99998 12H18C18.1768 12 18.3464 11.9297 18.4714 11.8047C18.5964 11.6797 18.6666 11.5101 18.6666 11.3333C18.6666 11.1565 18.5964 10.9869 18.4714 10.8619C18.3464 10.7369 18.1768 10.6666 18 10.6666H5.99998C5.82317 10.6666 5.6536 10.7369 5.52858 10.8619C5.40355 10.9869 5.33331 11.1565 5.33331 11.3333C5.33331 11.5101 5.40355 11.6797 5.52858 11.8047C5.6536 11.9297 5.82317 12 5.99998 12Z"
          fill="#514B4D"
        />
        <path
          d="M5.99998 14.6667H12.6666C12.8435 14.6667 13.013 14.5965 13.1381 14.4714C13.2631 14.3464 13.3333 14.1769 13.3333 14C13.3333 13.8232 13.2631 13.6537 13.1381 13.5286C13.013 13.4036 12.8435 13.3334 12.6666 13.3334H5.99998C5.82317 13.3334 5.6536 13.4036 5.52858 13.5286C5.40355 13.6537 5.33331 13.8232 5.33331 14C5.33331 14.1769 5.40355 14.3464 5.52858 14.4714C5.6536 14.5965 5.82317 14.6667 5.99998 14.6667Z"
          fill="#514B4D"
        />
      </g>
      <defs>
        <clipPath id="clip0_477_7992">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgConfigurationManagement;
